var _defs, _circle, _g, _g2, _g3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCustomerGroup = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "customer_group",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#babed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b1b6cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#babed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9399b5"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7095",
    "data-name": "Ellipse 7095",
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#eaeaf3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35395",
    "data-name": "Group 35395"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7096",
    "data-name": "Ellipse 7096",
    cx: 23.694,
    cy: 23.694,
    r: 23.694,
    transform: "translate(33.334 99.185)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63410",
    "data-name": "Path 63410",
    d: "M60.645,125a8.655,8.655,0,1,0-7.236,0,17.4,17.4,0,0,0-13.537,14.194,23.629,23.629,0,0,0,34.31,0A17.4,17.4,0,0,0,60.645,125Z",
    fill: "#969bb7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35396",
    "data-name": "Group 35396"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7097",
    "data-name": "Ellipse 7097",
    cx: 23.694,
    cy: 23.694,
    r: 23.694,
    transform: "translate(119.278 99.185)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63411",
    "data-name": "Path 63411",
    d: "M146.589,125a8.655,8.655,0,1,0-7.236,0,17.4,17.4,0,0,0-13.537,14.194,23.629,23.629,0,0,0,34.31,0A17.4,17.4,0,0,0,146.589,125Z",
    fill: "#969bb7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35397",
    "data-name": "Group 35397"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7098",
    "data-name": "Ellipse 7098",
    cx: 42.03,
    cy: 42.03,
    r: 42.03,
    transform: "translate(57.97 41.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63412",
    "data-name": "Path 63412",
    d: "M106.416,87.7a15.352,15.352,0,1,0-12.832,0,30.871,30.871,0,0,0-24.013,25.178,41.913,41.913,0,0,0,60.86,0A30.877,30.877,0,0,0,106.416,87.7Z",
    fill: "url(#linear-gradient-3)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCustomerGroup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/customer-group.5c469219.svg";
export { ForwardRef as ReactComponent };